import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/37b9d76f/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { CodeSnippet } from 'carbon-components-react';
import '@carbon/charts/styles.css';
import { SimpleBarChart, GroupedBarChart, StackedBarChart, PieChart, DonutChart, LineChart, ScatterChart } from '@carbon/charts-react';
import { addHeightToOptions // Bar
, groupedBarOptions, groupedBarData, groupedHorizontalBarOptions, groupedHorizontalBarData, simpleBarOptions, simpleBarData, simpleHorizontalBarOptions, simpleHorizontalBarData, simpleBarTimeSeriesOptions, simpleBarTimeSeriesData, simpleHorizontalBarTimeSeriesOptions, simpleHorizontalBarTimeSeriesData, stackedBarOptions, stackedBarData, stackedHorizontalBarOptions, stackedHorizontalBarData, stackedBarTimeSeriesOptions, stackedBarTimeSeriesData, stackedHorizontalBarTimeSeriesOptions, stackedHorizontalBarTimeSeriesData // Pie & donut
, pieOptions, pieData, donutOptions, donutData // Line
, lineTimeSeriesOptions, lineTimeSeriesData, lineData, lineOptions // Step
, stepOptions, stepData, stepTimeSeriesOptions, stepTimeSeriesData // Scatter
, scatterTimeSeriesOptions, scatterTimeSeriesData, scatterOptions, scatterData } from '../../../data/charts/index';
import AllDemos from './allDemos';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Basic charts offer a way to visualize data sets in an intuitive, easy to understand way. Every chart should tell a story and should reflect the content on the page where it is found.`}</p>
    </PageDescription>





    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Bar chart</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Line chart</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Area chart</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Polar charts</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Scatter plots</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Meter and gauge</AnchorLink>
    </AnchorLinks>
    <AllDemos mdxType="AllDemos" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      